// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { DismissIcon, Typography } from '@iheartjane/reefer';
import type { PropsWithChildren, ReactNode } from 'react';

import styles from './enticementBubble.module.css';

const Bubble = ({ children }: PropsWithChildren) => {
  return (
    <Typography
      as="div"
      color="grays-white"
      className={styles['bubble']}
      px={16}
      py={12}
      position="relative"
      textAlign="center"
      mt={16}
      whiteSpace="normal"
    >
      {children}
    </Typography>
  );
};

const CloseButton = styled.button(({ theme }) => ({
  border: `1px solid ${theme.colors.grays.ultralight}`,
  position: 'absolute' as const,
  width: 30,
  height: 30,
  borderRadius: 15,
  right: -8,
  top: -15,
  background: theme.colors.grays.white,
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.16)',
}));

interface Props {
  children: ReactNode;
  onClose?: () => void;
}

export const EnticementBubble = ({ children, onClose }: Props) => {
  const theme = useTheme();
  return (
    <Bubble>
      {onClose && (
        <CloseButton onClick={onClose} theme={theme}>
          <DismissIcon size="sm" color="grays-mid" />
        </CloseButton>
      )}
      {children}
    </Bubble>
  );
};
